import React, { memo } from "react";
import classnames from "classnames";
import Element from "src/components/base/element";

interface IProps {
    id?: string;
    className?: string;
    renderAs?: string;
    children: React.ReactNode;
    domRef?: any;
}

function Section(props: IProps) {
    const { className, id, children, renderAs = "div", ...rest } = props;
    return (
        <Element
            id={id}
            renderAs={renderAs}
            className={classnames("bm-section", "block", className)}
            {...rest}
        >
            {children}
        </Element>
    );
}

export default memo(Section);
